/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { dealerLocationMapStyles } from "@insite/content-library/Widgets/DealerDetails/DealerLocationMap";

dealerLocationMapStyles.locationGoogleMap = {
    googleMap: {
        zoom: 14,
        mapContainerStyle: {
            height: "100%",
            minHeight: "540px",
            width: "100%",
            marginTop: "30px",
        },
    },
};
